module.exports = __webpack_public_path__ + "img/area-comum-05.f14ad5c5.png";